import { render, staticRenderFns } from "./AssessModal.vue?vue&type=template&id=161b019a&scoped=true&"
import script from "./AssessModal.vue?vue&type=script&lang=js&"
export * from "./AssessModal.vue?vue&type=script&lang=js&"
import style0 from "./AssessModal.vue?vue&type=style&index=0&id=161b019a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161b019a",
  null
  
)

export default component.exports